import { combineReducers } from 'redux';

import appReducer from '../slices/appSlice.js';

import agencyAssessmentsReducer from '../../agency/redux/slices/agencyAssessmentsSlice.js';
import agencyFindingsReducer from '../../agency/redux/slices/agencyFindingsSlice.js';
import agencyAgentsReducer from '../../agency/redux/slices/agencyAgentsSlice.js';
import agencySkillsReducer from '../slices/agencySkillsSlice.js';
import agencyMethodsReducer from '../slices/agencyMethodsSlice.js';

const rootReducer = combineReducers({
  app: appReducer,
  agencyAssessments: agencyAssessmentsReducer,
  agencyFindings: agencyFindingsReducer,
  agencyAgents: agencyAgentsReducer,
  agencySkills: agencySkillsReducer,
  agencyMethods: agencyMethodsReducer,
});

export default rootReducer;
